
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface FileInfoFieldsProps {
  title: string;
  description: string;
  onTitleChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

export function FileInfoFields({ 
  title, 
  description, 
  onTitleChange, 
  onDescriptionChange 
}: FileInfoFieldsProps) {
  return (
    <>
      <div>
        <Label htmlFor="file-title">Τίτλος</Label>
        <Input 
          id="file-title"
          value={title || ''}
          onChange={(e) => onTitleChange(e.target.value)}
          className="mt-1"
          placeholder="Εισάγετε έναν τίτλο"
        />
      </div>
      
      <div>
        <Label htmlFor="file-description">Σύντομη Περιγραφή</Label>
        <Textarea 
          id="file-description"
          value={description || ''}
          onChange={(e) => onDescriptionChange(e.target.value)}
          className="mt-1"
          placeholder="Εισάγετε μια σύντομη περιγραφή"
          rows={3}
        />
      </div>
    </>
  );
}
